import dynamic from 'next/dynamic'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'
import DividerSection from '@segment/templates/DividerSection'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import GetMore from './components/GetMore'
import LeverageFacebookAds from './components/LeverageFacebookAds'

import ogImageJpeg from './assets/OgFacebookAds.jpeg'

const ImproveYourAds = dynamic(() => import(`./components/ImproveYourAds`))
const CustomerStory = dynamic(() => import(`./components/CustomerStory`))
const GettingStarted = dynamic(() => import(`@segment/templates/GettingStarted`))

const FacebookAdsView = () => (
  <AppearanceProvider appearance="twilioLight">
    <Layout
      pageTitle="Maximize your Facebook Ads ROI | Twilio Segment"
      pageDescription="Instrument Twilio Segment once and access the full Facebook Ads suite to optimize your ad campaigns for repeatable and scalable results."
      pageOG={ogImageJpeg}
    >
      <NavigationV2 />
      <Hero />
      <main>
        <LeverageFacebookAds />
        <ImproveYourAds />
        <DividerSection />
        <GetMore />
        <CustomerStory />
        <GettingStarted />
      </main>
    </Layout>
    <Footer />
  </AppearanceProvider>
)

export default FacebookAdsView
